import React, { FunctionComponent, useRef, useEffect } from 'react';
import classNames from 'classnames';
import { WarningIcon } from '../SvgIcons';

// Import Local Styles
import styles from './alertBanner.module.css';

export interface AlertBannerProps {
  type: string;
  setClosedBanner: (set: boolean) => void;
  closedBanner: boolean;
  children: JSX.Element;
}

export const AlertBanner: FunctionComponent<AlertBannerProps> = (props) => {
  const { type, children, setClosedBanner, closedBanner } = props;

  const alertBannerClassNames = classNames({
    [styles.wrapper]: true,
    [styles[type]]: type === 'error' || type === 'warning',
  });

  const errorBannerRef = useRef(null);

  useEffect(() => {
    const currentBannerRef: any = errorBannerRef.current;
    if (currentBannerRef) currentBannerRef.scrollIntoView({ behavior: 'smooth' });
  });

  return (
    <>
      {closedBanner && (
        <div
          ref={errorBannerRef}
          className={alertBannerClassNames}
          onClick={() => {
            setClosedBanner(false);
          }}
        >
          <div className={styles.message}>
            <WarningIcon />
            {children}
          </div>
        </div>
      )}
    </>
  );
};
